import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCompassPointer"><Path d="M21.207 21.0625L12 17.7959L2.79297 21.0625L12 1.75781L21.207 21.0625Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCompassPointer;
